import { PayloadAction } from '../../../store.model';
import { ActionType } from '../form.action';
import { defaultState, FormState } from '../form.state';

import { Reset } from './reset.action';

export function resetReducer(
    state: FormState,
    _: PayloadAction<ActionType.EVAL_FORM__RESET, Reset>,
): FormState {
    return defaultState();
}
